import { Dispatch } from 'react';
import devPortalConstant from '../constants';
import {
  dependenciesType,
  OauthType,
  whiteListedDomainsType
} from 'features/code-editor/types';

export interface IUserLoggedIn {
  type: string;
  payload: boolean;
}

interface IUserRedirect {
  type: string;
  payload: boolean;
}

interface IActionType {
  type: string;
  payload: any;
}

export const setIsUserLoggedIn =
  (value: boolean) => (dispatch: Dispatch<IUserLoggedIn>) => {
    const { SET_LOGGED_IN_USER } = devPortalConstant;
    dispatch({ type: SET_LOGGED_IN_USER, payload: value });
  };

export const setUserRedirect =
  (value: boolean) => (disptach: Dispatch<IUserRedirect>) => {
    const { SET_USER_REDIRECT } = devPortalConstant;
    disptach({ type: SET_USER_REDIRECT, payload: value });
  };

export const setWebhookApp =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_WEBHOOK_APP } = devPortalConstant;
    dispatch({ type: SET_WEBHOOK_APP, payload: value });
  };

export const clearWebhookApp = () => (dispatch: Dispatch<{ type: string }>) => {
  const { CLEAR_WEBHOOK_APP } = devPortalConstant;
  dispatch({ type: CLEAR_WEBHOOK_APP });
};

export const setOauthApp =
  (value: OauthType) => (dispatch: Dispatch<IActionType>) => {
    const { SET_OUATH_APP } = devPortalConstant;
    dispatch({ type: SET_OUATH_APP, payload: value });
  };

export const setIparamApp =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_IPARAM_APP } = devPortalConstant;
    dispatch({ type: SET_IPARAM_APP, payload: value });
  };

export const setEventFields =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_EVENT_FIELDS } = devPortalConstant;
    dispatch({ type: SET_EVENT_FIELDS, payload: value });
  };

export const setWhitelistedDomains =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_WHITELISTED_DOMAINS } = devPortalConstant;
    dispatch({ type: SET_WHITELISTED_DOMAINS, payload: value });
  };

export const setDependencies =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_DEPENDENCIES } = devPortalConstant;
    dispatch({ type: SET_DEPENDENCIES, payload: value });
  };

export const setAppValidation =
  ({
    isValidated,
    message,
    error
  }: {
    isValidated: boolean;
    message?: string;
    error?: string;
  }) =>
  (dispatch: Dispatch<IActionType>) => {
    const { SET_APP_VALIDATION } = devPortalConstant;
    dispatch({
      type: SET_APP_VALIDATION,
      payload: {
        isValidated,
        message,
        error
      }
    });
  };

export const setCurrentApp =
  (value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_CURRENT_APP } = devPortalConstant;
    dispatch({ type: SET_CURRENT_APP, payload: value });
  };

export const clearCodeEditor = () => (dispatch: Dispatch<{ type: string }>) => {
  const { CLEAR_CURRENT_APP } = devPortalConstant;
  dispatch({ type: CLEAR_CURRENT_APP });
};

export const handleTooltipContent =
  (property: string, value: any) => (dispatch: Dispatch<IActionType>) => {
    const { SET_TOOLTIP_VALUE } = devPortalConstant;
    dispatch({
      type: SET_TOOLTIP_VALUE,
      payload: {
        property,
        value
      }
    });
  };

export const updateSettings = (settings: {
  whitelistedDomains: whiteListedDomainsType[];
  dependencies: dependenciesType[];
}) => ({
  type: devPortalConstant.UPDATE_SETTINGS,
  payload: settings
});


export const setSimulateCode = (field: string, simulateCode: any) => (dispatch: Dispatch<IActionType>) => {
  const { SET_SIMULATE_CODE } = devPortalConstant;
  dispatch({
    type: SET_SIMULATE_CODE,
    payload: {
      field,
      simulateCode
    }
  })
}